<template>
	<v-card tile elevation="0" style="height: 100%" class="overflow-y-hidden">
		<v-card-title class="card-header text-left fixed-card-title2">
			<v-row dense>
				<v-col cols="10" class="d-flex align-center justify-start">
					<v-toolbar-title>{{ $t('View-Assessment') }}</v-toolbar-title>
				</v-col>
				<v-col cols="2" class="d-flex align-center justify-end">
					<v-icon left @click="synchronizeDrawers" color="white" class="camel-case custom-outlined-color pr-1">
						mdi-pencil
					</v-icon>
					<v-icon color="white" height="36" @click="closeEditDrawerDetails" class="custom-outlined-color ml-n2">
						mdi-close
					</v-icon>
				</v-col>
			</v-row>
		</v-card-title>
		<v-card-text class="pt-4 d-flex flex-column overflow-hidden" style="height: calc(100vh - 62px)">
			<div class="d-flex flex-column h-100" style="min-height: 0">
				<v-row dense class="flex-shrink-1 flex-grow-0">
					<v-col cols="9" class="text-left">
						<span class="font-weight-bold font-size16 color-black">{{ surveyData.templateName }}</span>
					</v-col>
					<v-col cols="3" class="text-right">
						<span
							:style="
								surveyData.status === 1
									? 'color: #52C41A; font-weight: bold'
									: 'color: gray; font-weight: bold; font-size: 0.8em'
							">
							<v-icon
								small
								:style="
									surveyData.status === 1 ? 'color: #52C41A; font-weight: bold' : 'color: gray; font-weight: bold'
								">
								mdi-checkbox-blank-circle
							</v-icon>
							{{ surveyData.status === 1 ? $t('active-caps') : $t('inactive-caps') }}
						</span>
					</v-col>
				</v-row>
				<div class="wellness-assessment-desc-border rounded">
					<span class="wellness-desc ma-2 mb-0">{{ $t('description') }}</span>
					<span class="wellness-detail-desc ma-2">{{ surveyData.templateDescription }}</span>
				</div>
				<div class="d-flex flex-column min-height-0 overflow-hidden mt-2 elevation-2">
					<v-card class="min-height-0 overflow-auto">
						<v-card-title>
							<span class="wellness-assessment-questions">{{ $t('questions') }}</span>
						</v-card-title>
						<v-expansion-panels accordion style="height: calc(100% - 64px)">
							<v-expansion-panel v-for="(question, index) in surveyById.questionsListWithAnswers" :key="index">
								<v-expansion-panel-header>
									<div class="font-weight-medium">
										<v-avatar size="26" max-width="20" color="chips" class="text-color-white mr-2">
											{{ index + 1 }}
										</v-avatar>
										<span class="line-height1-2"> {{ question.question }}</span>
									</div>
								</v-expansion-panel-header>
								<v-expansion-panel-content
									class="text-left"
									v-for="(answer, answerIndex) in question.offeredAnswersList"
									:key="answerIndex">
									<v-icon v-if="answer.possibleAnswer.trim() !== ''">mdi-chevron-right</v-icon>
									<span class="font-weight-bold">
										{{ answer.possibleAnswer }}
									</span>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-card>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState({
			verifiers: (state) => state.verifiers.verifiers,
			surveyById: (state) => state.mentalhealth.survey,
		}),
		surveyData () {
			return this.surveyById ? this.surveyById : {};
		},
		updateDrawer () {
			return this.$store.state.updateDrawer;
		},
	},
	beforeDestroy () {
		this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
	},
	methods: {
		closeEditDrawerDetails () {
			this.$store.commit('mentalhealth/CLEAR_CURRENT_SURVEY_TEMPLATE', null);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},
		synchronizeDrawers () {
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'wellnessassessments',
			});
		},
	},
};
</script>
